import { Component, OnInit } from '@angular/core';
import { UserService } from '../../service/user.service';
import * as firebase from 'firebase';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { MyfireService } from '../../service/myfire.service';

@Component({
  selector: 'app-zakazivanje',
  templateUrl: './zakazivanje.component.html',
  styleUrls: ['./zakazivanje.component.css']
})
export class ZakazivanjeComponent implements OnInit {
  searchText = '';
  users: any = [];
  user: any;
  errorZak = false;
  toggleForm = false;
  today: any;
  datum = false;
  userRef: any;
  doktorRef: any;
  pacijentRef: any;
  pacijent: Array<any> = [];
  doktorArr: Array<any> = [];
  pronadjen: Array<any> = [];
  zakazaivanjeDanas = new Date();
  danas = new Date().getDate();

  constructor(
    private router: Router,
    private userService: UserService,
    private location: Location,
    private http: HttpClient,
    private myFire: MyfireService
  ) {
    this.today = new Date().valueOf();
    this.user = userService.getProfile();
    this.doktorRef = firebase.database().ref('ordinacija/');
    this.userRef = firebase.database().ref('/users/');
  }
  toggleZakazivanje() {
    this.toggleForm = !this.toggleForm;
  }
  getMyStyles(dan, sutra) {
    let myStyles;

    if (dan === this.danas) {
      myStyles = {
        color: 'red'
      };
    } else {
      myStyles = {
        color: 'blue'
      };
    }
    return myStyles;
  }
  zakazi(form: NgForm) {
    this.pacijent = [];
    this.pronadjen = [];
    const ime = form.value.name;
    const email = form.value.email;
    const telefon = form.value.tel;
    const date = form.value.date;
    const sati = form.value.sati;
    const minuti = form.value.minuti;
    const doktor = form.value.izaberiDoktora;
    const time = `${sati}:${minuti}`;
    const ord = form.value.ord;
    const sent = false;
    const key = `/${ime}${new Date().valueOf()}/`;
    const db = firebase.database().ref();
    const pacijentRef = db.child('ordinacija/' + doktor);
    const query = pacijentRef.orderByChild('doktor').equalTo(doktor);
    const dan = new Date(date).getDate();
    const sutra = new Date(date).getDate() + 1;
    if (Number(sati) > 23 || Number(sati) <= 0) {
      alert('Format sata: 00h - 23h');
      return !form.valid;
    }
    if (Number(minuti) > 59) {
      alert('Format minuta: 00min - 59min');
      return !form.valid;
    }
    if (!(sati.length === 2 && minuti.length === 2)) {
      alert('Format vremena: 24h');
      return !form.valid;
    }

    if (
      Number(
        new Date(date)
          .valueOf()
          .toString()
          .toString()
          .slice(0, 6)
      ) <
      Number(
        this.zakazaivanjeDanas
          .valueOf()
          .toString()
          .slice(0, 6)
      ) -
      10
    ) {
      alert('Ne mozete uneti datum manji od danasnjeg za datum pregleda!');
      return;
    }
    query.on('child_added', snap => {
      this.pronadjen.push({
        data: snap.val()
      });
    });
    if (this.pronadjen.length > 0) {
      this.pronadjen.map(item => {
        if (
          item.data.date === date &&
          item.data.doktor === doktor &&
          item.data.sati === sati &&
          item.data.minuti === minuti
        ) {
          this.pacijent.push(item);
        }
      });
    }
    if (this.pacijent.length > 0) {
      this.errorZak = true;
      return;
    }
    if (this.pacijent.length === 0) {
      this.errorZak = false;
      firebase
        .database()
        .ref('ordinacija/' + doktor + key)
        .set({
          ime,
          sati,
          minuti,
          doktor,
          time,
          date,
          telefon,
          email,
          sent,
          ord,
          dan,
          sutra
        })
        .then(() => {
          form.resetForm();
        });
    }
    if (this.pronadjen.length === 0) {
      firebase
        .database()
        .ref('ordinacija/' + doktor + key)
        .set({
          ime,
          sati,
          minuti,
          doktor,
          time,
          date,
          telefon,
          email,
          sent
        })
        .then(() => {
          form.resetForm();
        });
    }
  }
  delete(key, doktor) {
    if (
      confirm('Da li ste sigurni da zelite da obriste zakazanog pacijenta?')
    ) {
      firebase
        .database()
        .ref('ordinacija/' + doktor + '/' + key)
        .remove()
        .then(() => {
          this.router.navigate(['brisanje']);
        })
        .then(() => {
          this.location.back();
        });
    }
  }

  ngOnInit() {
    this.userRef.on('child_added', data => {
      this.users.push({
        key: data.key,
        data: data.val()
      });
    });
    this.doktorRef.on('child_added', data => {
      const key = data.key;

      firebase
        .database()
        .ref('/ordinacija/' + key)
        .on('child_added', datas => {
          this.doktorArr.push({
            key: datas.key,
            data: datas.val()
          });

          this.doktorArr.sort((a, b) => {
            const dateA = new Date(a.data.date).valueOf();
            const dateB = new Date(b.data.date).valueOf();
            return (
              dateA - dateB ||
              a.data.sati - b.data.sati ||
              a.data.minuti - b.data.minuti
            );
          });
        });
    });
  }

  async podsetiTermin(ime, email, datum, sati, minuti, doktor) {
    const vreme = sati + ':' + minuti;
    const datumSredjen = moment(datum).format('DD.MM.YYYY.');

    await this.http
      .get(
        `${this.myFire.getUrl()}dest=${email}&datum=${datumSredjen}&vreme=${vreme}&ime=${ime}&doktor=${doktor}`,
        { responseType: 'text' }
      )
      .subscribe();
  }
}
